// Device ID + pending-claim helpers, backed by localStorage (NOT
// sessionStorage — sessionStorage dies during OAuth round-trips on
// Android Custom Tabs and Chrome web signin. See handoff decision
// Aug 23, 2026).
const DEVICE_ID_KEY = 'brainsync_device_id';
const PENDING_CLAIM_KEY = 'brainsync_pending_claim';

export function getDeviceId() {
    try {
        let id = localStorage.getItem(DEVICE_ID_KEY);
        if (id && id.length >= 16) return id;
        id = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36)).replace(/-/g, '');
        localStorage.setItem(DEVICE_ID_KEY, id);
        return id;
    } catch {
        // Private-browsing / storage blocked. Fall back to a per-session id.
        return 'ephemeral_' + Math.random().toString(36).slice(2);
    }
}

export function stashPendingClaim(bookmarkId) {
    try {
        const payload = { bookmark_id: bookmarkId, device_id: getDeviceId(), ts: Date.now() };
        localStorage.setItem(PENDING_CLAIM_KEY, JSON.stringify(payload));
    } catch {}
}

export function readPendingClaim() {
    try {
        const raw = localStorage.getItem(PENDING_CLAIM_KEY);
        if (!raw) return null;
        const p = JSON.parse(raw);
        // 7-day sanity ceiling — matches backend expiry.
        if (!p || !p.bookmark_id || Date.now() - (p.ts || 0) > 7 * 24 * 3600 * 1000) return null;
        return p;
    } catch {
        return null;
    }
}

export function clearPendingClaim() {
    try {
        localStorage.removeItem(PENDING_CLAIM_KEY);
    } catch {}
}
